import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { OffsetContainer } from '../css';
import PrimaryButton from '../../ReactComponent/PrimaryButton';

const Button = ({ text, children, ...rest }) => (
  <OffsetContainer>
    <PrimaryButton
      type="button"
      iconRightArrow
      autoWidth
      {...rest}
    >
      {text ? <Text field={text} /> : children}
    </PrimaryButton>
  </OffsetContainer>
);

Button.propTypes = {
  text: PropTypes.object,
  children: PropTypes.node,
};

export default Button;
